// extracted by mini-css-extract-plugin
export var lg = "_es-7";
export var md = "_es-6";
export var placeholderContainer = "_es-1";
export var placeholderIcon = "_es-2";
export var productImage = "_es-0";
export var sm = "_es-5";
export var xl = "_es-8";
export var xs = "_es-4";
export var xxs = "_es-3";